import { assignIn } from 'lodash-es'
import moment from 'moment'

export class Session {
  constructor(session) {
    if (session === null || session === undefined) {
      this.uuid = null
      this.maskedEmail = null
      this.accountType = 'NONE'
      this.joinYmdt = null
    } else {
      assignIn(this, assignIn(this, session))
    }
  }

  isJoinAfterCertainDate() {
    if (this.joinYmdt === null || this.joinYmdt === undefined) {
      return false
    }

    return moment(this.joinYmdt).isSameOrAfter('2020-05-25')
  }

  isAccountTypeCorporation() {
    return this.accountType == 'CORPORATION'
  }
}
